import { createTheme } from "@mui/material/styles";

import { brand } from "./brandColors";

// Maps the Pedestal Health brand palette (see brandColors.ts) into
// MUI's semantic palette slots. Components keep referencing primary/
// secondary/success/etc. — when the brand evolves, only this file (and
// brandColors.ts) need to change.
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: brand.azure,
      light: brand.pedestalBlue,
      dark: brand.navy,
      contrastText: brand.white,
    },
    secondary: {
      main: brand.pedestalBlue,
      dark: brand.ocean,
      contrastText: brand.black,
    },
    background: {
      default: brand.pearl,
      paper: brand.white,
    },
    text: {
      primary: brand.black,
      secondary: brand.graphite,
      disabled: brand.silver,
    },
    success: { main: brand.forest, contrastText: brand.white },
    warning: { main: brand.orange, contrastText: brand.black },
    error: { main: brand.crimson, contrastText: brand.white },
    info: { main: brand.aqua, contrastText: brand.black },
    // No explicit ``divider`` override — Silver (#ADADAD) would be
    // too heavy for hairline dividers. MUI's default rgba(0,0,0,0.12)
    // stays in effect.
  },
  typography: {
    fontFamily: "'Inter', 'ui-sans-serif', 'system-ui', '-apple-system', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCard: {
      defaultProps: { variant: "outlined" },
      styleOverrides: {
        root: {
          borderColor: "#E5E5E7",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          color: brand.graphite,
          fontSize: "0.8125rem",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
